import React, { memo, useEffect, useRef } from "react";
import { Network } from "vis-network/peer/esm/vis-network";
import { DataSet } from "vis-data/peer/esm/vis-data";
import { GraphContext } from "../context";
import { alpaphaImage } from "../helpers/image";
import { alpaphat } from "../data/assetsData";
// import "vis-network/styles/vis-network.css";
// import BFS from "../helpers/Bfs";

const NetworkVisualization = ({
  data,
  connection,
  chatType,
  setNodes,
  setEdges,
  traversingEdge,
}) => {
  const containerRef = useRef(null);
  const network = useRef(null);

  // let validPath = BFS(numberOfNodes, edges, 1, 5);
  useEffect(() => {
    let nodes = new DataSet(data.nodes);
    let edges = new DataSet(data.edges);
    console.log(data.edges, traversingEdge);
    if (traversingEdge.length > 0) {
      const updatedInitialEdge = data.edges.map((edge) => {
        const matchingEdge = traversingEdge.find(
          (updated) => updated.id === edge.id
        );
        console.log({ ...edge, ...matchingEdge });
        if (matchingEdge) {
          return { ...edge, ...matchingEdge };
        }
        return edge;
      });
      console.log(updatedInitialEdge);
      edges = new DataSet(updatedInitialEdge);
    } else {
      edges = new DataSet(data.edges);
    }
    const options = {
      physics: {
        enabled: true,

        stabilization: {
          fit: true,
        },
      },
      clickToUse: true,
      interaction: {
        dragView: false,
        drandNode: true,
      },
      // solver: "forceAtlas2Based",
      edges: {
        color: {
          color: "white",
        },

        smooth: {
          type: "continuous",
        },
        arrows: {
          to: {
            enabled: connection === "Directed" ? true : false,
            scaleFactor: 1,
          },
        },
      },
      nodes: {
        borderWidth: 1,
        borderWidthSelected: 2,
        brokenImage: undefined,
        size: 15,
        font: {
          color: "red",
          size: 16,
          bold: {
            size: 20,
          },
        },
        chosen: {
          node: function (values, id, selected, hovering) {
            values.borderWidth = selected || hovering ? 3 : 1;
            values.borderColor = selected || hovering ? "red" : "green";
          },
        },
        mass: 1,
        physics: false,
      },
      interaction: {
        zoomView: false,
        dragView: false,
      },
    };
    const container = containerRef.current;
    network.current = new Network(container, { nodes, edges }, options);
    if (network.current) {
      network.current.fit();
    }

    let heldNodeId = [];
    let storeAllEdges = [];
    network.current.on("doubleClick", function (params) {
      if (chatType === "Custom") {
        const newNodeId = nodes.get().length + 1;

        if (newNodeId > 30) alert("We can generate only below 30 nodes");

        // const alpaphat = [...Array(26)].map((_, i) =>
        //   String.fromCharCode(i + 65)
        // );
        // Add new node
        const newNode = {
          id: newNodeId,
          image: alpaphaImage[newNodeId - 1],
          shape: "circularImage",
          label: "0",
          title: alpaphat[newNodeId - 1],
          x: params.pointer.canvas.x,
          y: params.pointer.canvas.y,
        };

        nodes.update(newNode);
        setNodes(nodes.get());
      }
    });
    network.current.on("oncontext", function (params) {
      const nodeId = params.nodes[0];

      if (nodeId !== undefined && chatType === "Custom") {
        const node = data.nodes.find((n) => n.id === nodeId);
        const newLabel = prompt("Enter a new label for the node:", node.label);
        // params.stopImmediatePropagation();
        if (newLabel !== null) {
          node.label = newLabel;
          nodes.update(node);
        }
        network.current.selectNodes([]);
        heldNodeId = [];
      }
    });
    network.current.on("release", (event) => {
      // network.current.stabilize();
      network.current.setOptions({
        physics: {
          enabled: true,
          stabilization: {
            fit: false,
          },
        },
      });
      const draggableNodeId = event.nodes[0];

      const node = nodes.get(draggableNodeId);

      const newPosition = network.current.getPositions([draggableNodeId]);
      const position = newPosition[draggableNodeId];
      if (position) {
        const newXPosition = position.x;
        const newYPosition = position.y;

        node.x = newXPosition;
        node.y = newYPosition;

        nodes.update(node);
      }
    });

    network.current.on("click", (event) => {
      if (chatType === "Custom") {
        const { nodes } = event;
        const nodeId = nodes[0];
        // heldNodeId.push(nodeId);

        if (nodes.length > 0) {
          heldNodeId.push(nodeId);
        }
        const checkIsUndefined = heldNodeId.filter((item) => item);
        if (
          heldNodeId.length === 2 &&
          checkIsUndefined.length > 0 &&
          heldNodeId[0] !== heldNodeId[1]
        ) {
          console.log(heldNodeId);
          const fromNode = heldNodeId[0];
          const toNode = heldNodeId[1];
          const isDuplicateEdge = edges.get().some((edge) => {
            return edge.from === fromNode && edge.to === toNode;
          });
          if (isDuplicateEdge)
            alert("Selected node and target node edges already created");
          if (!isDuplicateEdge) {
            const edge = {
              from: heldNodeId[0],
              to: heldNodeId[1],
              id: edges.get().length + 1,
              physics: true,
            };
            edges.update(edge);
            setEdges(edges.get());
          }
          heldNodeId = [];
        }
      }
    });

    return () => {
      if (network.current) {
        network.current.destroy();
        network.current = null;
      }
    };
  }, [data]);

  return <div style={{ width: "100%", height: "100vh" }} ref={containerRef} />;
};

export default memo(NetworkVisualization);
